webpackJsonp([22],{

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(12);

var _reactHelmet = __webpack_require__(31);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _storyblokReact = __webpack_require__(30);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

__webpack_require__(497);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var converter = new _showdown2.default.Converter();

var CaseStudies = function CaseStudies(props) {
  var content = props.data.content;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        content && content.top[0].title
      )
    ),
    content && content.top.map(function (el) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { content: el, key: el._uid },
        _react2.default.createElement(
          'div',
          {
            className: 'hero hero--big hero--case',
            style: {
              backgroundImage: 'url(' + el.image + ')',
              backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
            }
          },
          _react2.default.createElement('div', { className: 'hero__overlay' }),
          _react2.default.createElement(
            'div',
            { className: 'news__title' },
            _react2.default.createElement(
              'div',
              { className: 'wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'offset-1' },
                _react2.default.createElement(
                  'p',
                  { className: 'hero__category' },
                  el.subtitle
                ),
                _react2.default.createElement(
                  'h1',
                  { className: 'hero__title' },
                  el.title
                )
              )
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'wrapper--small page-contents' },
      content.content.map(function (el) {
        return _react2.default.createElement(
          _storyblokReact2.default,
          { key: el._uid, content: el },
          el.component === 'Lead Paragraph' ? _react2.default.createElement(
            'p',
            { className: 'paragraph--lead' },
            el.text
          ) : _react2.default.createElement('div', {
            className: 'rich-text',
            dangerouslySetInnerHTML: {
              __html: converter.makeHtml(el.markdown)
            }
          })
        );
      })
    ),
    content.join_banner.map(function (el) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { key: el._uid, content: el },
        _react2.default.createElement(
          'div',
          { className: 'banner banner--green' },
          _react2.default.createElement(
            'div',
            { className: 'banner__image display-large', style: { backgroundImage: 'url(' + el.image + ')' } },
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'col-1-3' },
              _react2.default.createElement(
                'h2',
                { className: 'heading--small bold' },
                el.heading
              ),
              _react2.default.createElement(
                'p',
                { className: 'paragraph--sans banner__text' },
                el.subheading
              ),
              _react2.default.createElement(
                _reactStatic.Link,
                { to: el.link[0].link.cached_url, className: 'button button--white' },
                el.link[0].label
              )
            )
          )
        )
      );
    })
  );
};

exports.default = (0, _reactStatic.withRouteData)(CaseStudies);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/CaseStudies.9c14c8d7.js